import React from 'react';
import {
  Richtext,
  TagOverrides,
  createTagOverride,
  TextCustom,
  TextTag,
  TextAppearance,
  TextWeight,
  TextAlignment,
  Breakpoints,
  TextSize,
  TextLineHeight,
} from '@vw-marketing/us-components';
import { StyledTwitterCarouselTitle } from './styled';

interface TwitterCarouselTitleProps {
  titleText?: string;
}
const TwitterCarouselTitle: React.FC<TwitterCarouselTitleProps> = (props) => {
  const title =
    props.titleText ||
    'See how our dealers across the United States **are showing up to help.**';
  const textStyle = {
    [Breakpoints.default]: {
      textAlign: TextAlignment.center,
    },
    [Breakpoints.b960]: {
      fontSize: TextSize.TextSize60,
      lineHeight: TextLineHeight.TextLineHeight68,
    },
  };
  const textStyleBold = {
    ...textStyle,
    [Breakpoints.default]: {
      ...textStyle[Breakpoints.default],
      fontWeight: TextWeight.bold,
    },
  };
  const tagOverrides: TagOverrides = {
    span: createTagOverride(TextCustom, {
      tag: TextTag.h2,
      appearance: TextAppearance.headline0350,
      style: textStyle,
    }),
    strong: createTagOverride(TextCustom, {
      tag: TextTag.strong,
      appearance: TextAppearance.headline0350,
      style: textStyleBold,
    }),
  };
  return (
    <StyledTwitterCarouselTitle className="twitter-carousel-title">
      <Richtext markdown={title} overrides={tagOverrides} />
    </StyledTwitterCarouselTitle>
  );
};

export default TwitterCarouselTitle;
